import React, {Component} from 'react';
const $ = require('jquery');
// $.DataTable = require('datatables.net');
// require( 'datatables.net-responsive' );
// import 'datatables.net-dt/css/jquery.dataTables.min.css';
// import Switch from 'react-bootstrap-switch';
// require('datatables.net-buttons/js/dataTables.buttons.min');
const jzip = require('jzip');
// require('datatables.net-buttons/js/buttons.html5.min');
// import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
// import Modal from 'react-bootstrap/Modal';
import ModalSetUser from '../modal/ModalSetUser';
window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);

const columns = [
  {
    title: '#',
    data: 'IS_ACTIVE',
    render: function (data, type, row) {
      // console.log(row);
      if (type === 'display') {
        if (data === true)
          return `<div class="custom-control custom-switch"><input id="customSwitch-${row.id}" type="checkbox" class="custom-control-input" checked/><label class="custom-control-label" for="customSwitch-${row.id}"></label></div>`;
        else
          return `<div class="custom-control custom-switch"><input id="customSwitch-${row.id}" type="checkbox" class="custom-control-input"/><label class="custom-control-label" for="customSwitch-${row.id}"></label></div>`;
      }
      return data;
    }
  },
  {
    title: 'ID',
    data: 'id'
  },
  {
    title: 'Username',
    data: 'USERNAME'
  },
  {
    title: 'Name',
    data: 'NAME'
  },
  {
    title: 'Phone',
    data: 'TEL'
  },
  {
    title: 'Email',
    data: 'EMAIL'
  },
  {
    title: 'View',
    data: 'id',
    render: function (data, type) {
      if (type === 'display') {
        return `<a class="text-muted"><i class="fas fa-search" /></a>`;
      }
      return data;
    }
  }
];

function reloadTableData(names) {
  console.log('reload: ' + names.length);
  const table = $(`#${id}`).DataTable();

  table.clear();
  table.rows.add(names);
  table.draw();
}

function updateTable(names, page) {
  console.log('update: ' + names.length);
  const table = $(`#${id}`).DataTable();
  let dataChanged = false;
  table.rows().every(function () {
    const oldNameData = this.data();
    const newNameData = names.find((item) => {
      return item.id === oldNameData.id;
    });

    if (
      oldNameData.IS_ACTIVE !== newNameData.IS_ACTIVE ||
      oldNameData.TEL !== newNameData.TEL
    ) {
      dataChanged = true;
      this.data(newNameData);
    }
    return true;
  });

  console.log(dataChanged);
  if (dataChanged) {
    //table.draw();
    table.page(page).draw('page');
  }
}

class TableUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: {USERNAME: 'HI'},
      onUpdate: () => {}
    };
    // this.selectRow = this.selectRow.bind(this);
  }

  componentDidMount() {
    var table = $(`#${id}`).DataTable({
      data: this.props.names,
      columns,
      searching: true,
      order: [[1, 'asc']],
      paging: true,
      ordering: true,
      autoWidth: true,
      // scrollX: true,
      responsive: true,
      columnDefs: [
        { target: 0, responsivePriority: 1 },
        { target: 1, responsivePriority: 1 },
        { target: 2, responsivePriority: 2 },
        { target: 3, responsivePriority: 2 },
        { target: 4, responsivePriority: 2 },
        { target: 5, visible: false},
        { targets: -1, responsivePriority: 1},
      ]
    });

    table.on('page', (event) => {
      var info = table.page.info();
      console.log(info.page);
      this.props.onPageChange(info.page);
    });

    $(`#${id} tbody`).on('click', 'a', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      this.setState({item: data});
      $('#exampleModal').modal('toggle');
    });

    $(`#${id} tbody`).on('change', 'input', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      this.setState({item: {...data, IS_ACTIVE: $this.prop('checked')}});
      this.state.onUpdate({...data, IS_ACTIVE: $this.prop('checked')});
    });

    this.setState({
      onUpdate: (item) => {
        this.props.onUpdate(item);
        $('#exampleModal').modal('hide');
      }
    });
  }

  componentWillUnmount() {
    $(`#${id}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.names.length !== this.props.names.length) {
      reloadTableData(nextProps.names);
    } else {
      updateTable(nextProps.names, nextProps.page);
    }

    return true;
  }

  render() {
    return (
      <div>
        <div
          className="modal fade"
          id="exampleModal"
          tabIndex={-1}
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                Customer Information
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <ModalSetUser
                  item={this.state.item}
                  onUpdate={this.state.onUpdate}
                ></ModalSetUser>
              </div>
            </div>
          </div>
        </div>
        {/* <button
                  type="button"
                  onClick={()=>{
                    alert(this.props.page);
                  }}
                >test</button> */}
        <table ref="main" className="display responsive nowrap" id={id} style={{width: '100%'}}/>
      </div>
    );
  }
}
export default TableUser;
